<ng-template #attente>
  <div class="car-page" style="justify-content: center; align-items: center; min-height: 50vh;">
    <div style="width: 200px;">
      <div class="car-progress-bar">
        <div class="car-progress-bar__inner"></div>
      </div>
      <p class="car-page__subtitle" style="text-align: center;">Chargement des marques...</p>
    </div>
  </div>
</ng-template>

<ng-container *ngIf="enregistrementTerminer; else attente">
  <div class="car-page">

    <div class="car-page__header">
      <h1 class="car-page__title">
        <div class="car-page__title-icon">
          <svg fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="18" height="18">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M9.568 3H5.25A2.25 2.25 0 003 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 005.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 009.568 3z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 6h.008v.008H6V6z" />
          </svg>
        </div>
        Gestion des Marques
      </h1>
      <p class="car-page__subtitle">Ajoutez, modifiez ou supprimez les marques de votre catalogue</p>
    </div>

    <div class="car-panel">
      <div class="car-panel__header">
        <div class="car-panel__header-left">
          <div class="car-panel__icon">
            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" width="14" height="14">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 002-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
          </div>
          Détails de la Marque
        </div>
      </div>

      <div class="car-panel__body">

        <div class="grp-form-strip" style="align-items: flex-end;">

          <div class="grp-img-upload" (click)="importer()" style="margin-right: 8px;">
            <div class="grp-img-upload__preview" style="width: 48px; height: 48px; border-radius: var(--radius-xs);">
              <img id="img_30_30" src="assets/icon.png" />
              <div class="grp-img-upload__overlay">
                <span>
                  <svg width="16" height="16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
                  </svg>
                </span>
              </div>
            </div>
            <input id="input_30_30" name="marqueIconUploader" type="file" style="display: none"
              (change)="onChangeImagefile($event)" [disabled]="isSaving" />
          </div>

          <div class="car-field">
            <label class="car-label">Code</label>
            <input class="car-input" name="marqueCodeInput" [(ngModel)]="marque.Marque_Code" placeholder="Code (Auto)"
              disabled="true" />
          </div>

          <div class="car-field car-field--grow">
            <label class="car-label">Nom de la Marque</label>
            <input class="car-input" name="marqueLabelInput" [(ngModel)]="marque.Marque_Label"
              placeholder="Ex: Samsung, Apple..." [disabled]="isSaving" />
          </div>

          <div class="car-toolbar" style="margin-bottom: 2px;">
            <button type="button" class="car-btn car-btn--primary" [disabled]="isSaving" (click)="addFiles()">
              <span *ngIf="isSaving" class="car-spinner"></span>
              Ajouter
            </button>
            <button type="button" class="car-btn car-btn--slate" [disabled]="isSaving" (click)="modifier()">
              <span *ngIf="isSaving" class="car-spinner"></span>
              Modifier
            </button>
            <button type="button" class="car-btn car-btn--danger" [disabled]="isSaving" (click)="supprimer()">
              <span *ngIf="isSaving" class="car-spinner"></span>
              Supprimer
            </button>
          </div>
        </div>

        <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 8px;">

          <div class="car-search" style="max-width: 300px;">
            <svg width="16" height="16" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
            <input class="car-search__input" name="marqueFilterInput" (keyup)="applyFilter($event.target.value)"
              placeholder="Filtrer les marques..." [disabled]="isSaving" />
          </div>

          <div class="car-table-wrap">
            <table id="tableCategories" class="car-table">
              <thead>
                <tr>
                  <th style="width: 80px;" class="center">Icon</th>
                  <th>Texte</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of (dataSource.data || dataSource)" (click)="selectRowGroupe($event, row)"
                  [class.selected]="marque.Marque_Code === row.Marque_Code">
                  <td class="center">
                    <div class="grp-thumb"
                      style="width: 34px; height: 34px; margin: 0 auto; border-radius: var(--radius-xs);">
                      <img *ngIf="row.Marque_Icon" [src]="generalService.base_url + 'images/' + row.Marque_Icon" />
                    </div>
                  </td>
                  <td class="bold">{{ row.Marque_Label }}</td>
                </tr>

                <tr *ngIf="!(dataSource.data || dataSource)?.length">
                  <td colspan="2" class="center" style="padding: 30px; color: var(--tx-subtle);">
                    Aucune marque trouvée.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>

  </div>
</ng-container>